import { StringUtility } from '../utility/string.utility';

export interface CallingTreeMemberJSON {
	userId: number;
	branch: number;
	name: string;
	firstName: string;
	lastName: string;
	role: string;
	phoneNumber: string;
	statusIndicator: number;
	status: string;
}

export class CallingTreeMember {
	constructor(
		public userId: number,
		public branch: number,
		public name: string,
		public firstName: string,
		public lastName: string,
		public role: string,
		public phoneNumber: string,
		public statusIndicator: number,
		public status: string
	) {}

	get firstLastName(): string {
		return `${this.firstName} ${this.lastName}`;
	}

	get lastFirstName(): string {
		return StringUtility.lastFirstName(this.lastName, this.firstName);
	}

	static fromJSON(json: CallingTreeMemberJSON): CallingTreeMember {
		return Object.assign(
			Object.create(CallingTreeMember.prototype),
			json,
			{}
		);
	}

	static sort(
		memberA: CallingTreeMember,
		memberB: CallingTreeMember
	): number {
		const lastName = memberA.lastName.localeCompare(memberB.lastName);
		return lastName !== 0
			? lastName
			: memberA.firstName.localeCompare(memberB.firstName);
	}

	isMemberRole(): boolean {
		return this.role === 'CTBM';
	}
}
